import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  const [userName, setUserName] = useState("");

  return (
    <BrowserRouter>
      <nav>
        <a
          href="https://notify-france.fr/"
          style={styles.left}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://img.notifyfrance.fr/notify-radius.png"
            alt="App Logo"
            style={styles.logo}
          />
          <h1 style={styles.title}>NOTIFY STOCK</h1>
        </a>
        <div style={styles.right}>{userName || "Loading..."}</div>
      </nav>
      <Routes>
        <Route path="/" element={<Home setUserName={setUserName} />} />
      </Routes>
    </BrowserRouter>
  );
}

const styles = {
  left: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    textDecoration: "none",
  },
  title: {
    marginLeft: "10px",
    fontSize: "18px",
    width: "max-content",
  },
  logo: {
    width: "32px",
    height: "32px",
    margin: "0px",
    borderRadius: "10px",
  },
  right: {
    textAlign: "right",
    width: "min-content",
  },
};

export default App;
